import React from "react"
import { MetricListProps } from "./interfaces"
import { Card } from "@walmart-web/livingdesign-components"
import Header from "./Header"
import Content from "./Content"
import Footer from "./Footer"
import { concatClassNames } from "helpers/jsxHelpers"

import "./index.scss"

const MetricSummaryCards: React.FC<MetricListProps> = (props) => {
	const { className, metricSummaries, alignment = "left" } = props
	return (
		<div
			data-testid={"metric-summary-cards"}
			className={concatClassNames(["list-card", `list-card-${alignment}`])}
		>
			{metricSummaries?.map(({ header, content, footer }) => (
				<Card
					key={`card-${header.title}`}
					className={concatClassNames(["metric-card", className])}
				>
					<Header {...header} />
					<Content {...content} />
					{footer.details && footer.details.length > 0 && (
						<Footer {...footer} />
					)}
				</Card>
			))}
		</div>
	)
}

export default MetricSummaryCards
